const PROPERTIES_MAP = {
  appId: 'fb:app_id'
};

export function createFacebookMetas(props = {}) {
  const allowedKeys = Object.keys(PROPERTIES_MAP);

  return allowedKeys.filter(key => typeof props[key] !== 'undefined').reduce(
    (acc, key) => [
      ...acc,
      {
        property: PROPERTIES_MAP[key],
        content: props[key]
      }
    ],
    []
  );
}

export default {
  createFacebookMetas
};
